var $ = require('jquery');
import inview from 'jquery-inview/jquery.inview';
import Headroom from 'headroom.js';
import * as ScrollMagic from "scrollmagic"; // Or use scrollmagic-with-ssr to avoid server rendering problems
import gsap from "gsap";
import 'magnific-popup';
import { ScrollTrigger } from "gsap/ScrollTrigger";


let clickEvent = '';
if ('ontouchstart' in window) {
	clickEvent = 'touchstart';
} else {
	clickEvent = 'click tap';
}

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
	// We execute the same script as before
	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${vh}px`);
});

$(document).ready(function () {
	initInviewAnimate();
	initHeadroom();
	handleHeaderMenuToggling();
	initMobileDrawer();
	initFooterPopups();
});

$(window).on('load', function () {
	// showBelowFold();
	initScrollToLocation();
	triggetURLScroll();
});


function triggetURLScroll() {
	var currentURL = window.location.href.split("#");
	var menu_target = "";

	if (currentURL.length > 1) {
		menu_target = currentURL[1].substring(0, currentURL[1].indexOf('?'));

		if (menu_target) {
			$("a[title=" + menu_target + "]").trigger("click");
		}

	}
}

function initScrollToLocation() {

	const triggers = $('.site-header__nav .menu-item a');
	var controller = new ScrollMagic.Controller({ globalSceneOptions: {} });

	triggers.each(function () {
		console.log('jdjkdjkjkdjkdjkjkdjk')
		const thisTrigger = $(this);
		const sectionClass = '.' + $(this).attr('href').split('#')[1];
		const sectionToScroll = $(sectionClass);
		const sectionHeight = sectionToScroll.height();
		if (sectionToScroll.length > 0) {
			new ScrollMagic.Scene({ triggerElement: sectionToScroll[0], triggerHook: 0.1, duration: sectionHeight, offset: -150 })
				.addTo(controller)
				.on("enter", function (e) {
					triggers.removeClass('active');
					thisTrigger.addClass('active');
					$('.site-header').removeClass('nav-show');
					$('body, html').removeClass('noscroll');
				})
				.on("progress", function (e) {
					if (e.scrollDirection == "FORWARD" && $(window).scrollTop() + $(window).height() + 200 >= $(document).height()) {
						triggers.removeClass('active');
						$('.site-header__nav .menu-item a[href="#news"]').addClass('active');
					}
				});


			thisTrigger.off('click').on('click', function (e) {
				e.preventDefault();

				// if ($(window).width() <= 991) {
				// 	$('body, html').removeClass('noscroll');
				// }

				$('html, body').animate({
					scrollTop: sectionToScroll.offset().top - 200
				});

			});
		}

	});

}

function showBelowFold() {
	$('section.section').css('display', 'block');
}

function initHeadroom() {
	var headerElements = document.getElementsByClassName("site-header"),
		headerElementsNo = headerElements.length;

	if (headerElementsNo > 0) {
		for (var i = 0; i < headerElementsNo; i++) {
			var headroom = new Headroom(headerElements[i]);
			headroom.init();
		}
	}
}

function initInviewAnimate() {
	var inviewElements = $(".inview-animate--fade")
		.add(".inview-animate--move-up")
		.add(".inview-animate--move-down")
		.add(".inview-animate--move-left")
		.add(".inview-animate--move-right")
		.add(".inview-animate--scale");

	inviewElements.each(function () {
		var thisInviewElement = $(this);

		thisInviewElement.bind('inview', function (event, visible) {
			if (visible == true) {
				thisInviewElement.addClass('inview-active');
			}
		});
	});
}


function handleHeaderMenuToggling() {
	var header = $(".site-header"),
		headerMenu = $(".site-header__nav-wrap"),
		headerBurger = $(".site-header__nav-trigger, .site-drawer__menu-toggle-close");

	if (headerMenu.length) {
		headerBurger.on("click", function () {
			var index = 0;

			$('body').toggleClass('noscroll');
			$(this).toggleClass("active");
			headerMenu.toggleClass("menu-active menu-closed");
			header.toggleClass("nav-active");
		});
	}
}

function initMobileDrawer() {
	$('.site-header__mobile-trigger').on('click', function (e) {
		e.preventDefault();
		$('.site-header').toggleClass('nav-show');
		$('body, html').toggleClass('noscroll');
	});
}



function initFooterPopups() {
	$('.site-footer__nav a, .site-popup a').on('click', function (e) {

		if ($(this).attr('href').indexOf('#') > -1) {
			e.preventDefault();
		} else {
			return true;
		}

		let popup = null;
		const target = $(this).attr('href').split('#')[1];

		if (target == 'privacy') {
			popup = $('.privacy-popup');
		} else if (target == 'terms') {
			popup = $('.terms-popup');
		}

		if ($('body').find('.mfp-wrap').length) {
			$.magnificPopup.close();
			setTimeout(function () {
				$.magnificPopup.open({
					items: {
						src: popup
					},
					type: 'inline',
					removalDelay: 300,
					mainClass: 'mfp-fade',
					showCloseBtn: false
				});
			}, 300);
		} else {
			$.magnificPopup.open({
				items: {
					src: popup
				},
				type: 'inline',
				removalDelay: 300,
				mainClass: 'mfp-fade',
				showCloseBtn: false
			});
		}
	});

	$('.site-popup__close').off('click').on('click', function (e) {
		e.preventDefault();

		$.magnificPopup.close();
	});
}



//site-content padding
var headerHeight = $('.site-header').innerHeight();
var siteContent = $('.site-inner');

siteContent.css("padding-top", headerHeight + 'px');

$(window).resize(function () {
	//site-content padding
	var headerHeight = $('.site-header').innerHeight();
	var siteContent = $('.site-inner');

	siteContent.css("padding-top", headerHeight + 'px');
});


gsap.registerPlugin(ScrollTrigger);

$(window).on('load', function () {
	initpipelinetrigger();
});

function initpipelinetrigger() {
	let allProgressBars = $('.progress-bar')
	allProgressBars && allProgressBars.each((index, progressBar) => {
		let width = $(progressBar).attr('data-width');
		gsap.to(progressBar, {
			width,
			duration: 3,
			stagger: .5,
			scrollTrigger: {
				trigger: '.pipeline-block',
				start: 200,
			},
		});
	})
}


//pipeline
$('.accordion .accordion-title').on('click', (e) => {
	let accordionList = e.target.closest('.accordion-list');
	$(accordionList).toggleClass('expanded');
})

//smooth scroll
$('.hero .btn-down button').on('click', (e) => {
	$("#who-block")[0].scrollIntoView({ behavior: 'smooth' });

});

//smooth scroll
$('.approach-block .btn-wrap .pipeline-btn').on('click', (e) => {
	$("#pipeline-block__wrap")[0].scrollIntoView({ behavior: 'smooth' });

});
